<template>
  <div>
    <div class="contract-container flex flex-justify_between">
      <div class="contract-wrap">
        <div class="title-wrap flex justify-content__center align-item__center" style="height: 40px;">
          申请合约
        </div>
        <div>
          <div class="tag-group__title">合同类型</div>
          <el-tag
              v-for="(i,idx) in modes"
              :key="i.id" @click="tagClick1(idx)"
              effect="dark" class="tag_div" :class="{'tab_active': modeId === i.id}">
            {{ i.name }}
          </el-tag>
        </div>
        <div>
          <div class="tag-group__title">保证金</div>
          <el-tag
              v-for="i in deposits"
              :key="i.id" v-if="checkDeposits(i.id)"
              effect="dark" class="tag_div" :class="{'tab_active': depositId === i.id}">
            {{ i.name }}
          </el-tag>
        </div>
        <div>
          <div class="tag-group__title">申请额度(500)</div>
          <el-tag
              v-for="i in levers"
              :key="i.id" v-if="checkLerver(i.id)"
              effect="dark" class="tag_div" :class="{'tab_active': leverId === i.id}">
            {{ i.name }}
          </el-tag>
        </div>
        <!--        <div class="pd5">确认信息</div>-->
        <!--        <div class="pd5">保证金</div>-->
        <!--        <div class="pd5">配资资金</div>-->
        <!--        <div class="pd5">总操盘资金</div>-->
        <!--        <div class="pd5">预警线</div>-->
        <!--        <div class="pd5">平仓线</div>-->
        <!--        <div class="pd5">利率</div>-->
        <!--        <div class="pd5">利息</div>-->
        <!--        <div class="pd5">合约期限</div>-->
        <!--        <div class="pd5">个股仓位限制</div>-->
        <div class="pd5">
          <el-checkbox v-model="checked">我已阅读并同意</el-checkbox>
          <div class="xy_div">《配置协议》</div>
        </div>
        <div class="pd5" style="margin-bottom: 100px">
          <button type="button" class="sub_btn" :disabled="submitting" @click="submitClick()">{{ submitting ? '处理中…' : '确认提交' }}</button>
        </div>
<!--        <div class="pd5">选择合约类型</div>-->
<!--        <div class="pd5" style="margin-top: 20px;">输入保证金</div>-->
<!--        <div class="pd5">-->
<!--          <el-input v-model="content" placeholder="请输入内容" class="content_box"></el-input>-->
<!--        </div>-->
<!--        <div class="pd5">申请配资资金</div>-->
      </div>
      <div class="swiper-wrap">
        <div>
          <a-carousel  autoplay>
            <div v-for="i in bannerList"><img :src="i.img" alt="" style="width: 100%;height: 100%"></div>
          </a-carousel>
        </div>

        <div class="title_div">
          <div class="title_box" style="margin-left: 20px">进行中</div>
          <div class="title_box">已结算</div>
          <div class="title_box div_right">按天</div>
          <div class="title_box div_right">按周</div>
          <div class="title_box div_right">按月</div>
          <div class="title_box div_right">免息</div>
        </div>
      </div>
      <div class="tips-wrap">
        <div class="title-wrap flex justify-content__center  align-item__center" style="height: 40px;">
          温馨提示
        </div>
        <div class="pd5" style="margin-top: 20px">下载APP可随时查看股票</div>
        <div class="pd5">实时行情动态及活动,请扫描下方二维码</div>
        <div class="pd5">
          <el-link :href="app.android" type="warning" download target="_blank" style="color: var(--theme-label);">下载配置APP</el-link>
        </div>
        <div>
          <img :src="app.android_scan" alt="" style="width: 200px;height: 200px">
        </div>
        <div class="pd5">安卓扫码下载</div>
        <div style="margin-top: 20px">
          <img :src="app.iosApp_scan" alt="" style="width: 200px;height: 200px">
        </div>
        <div class="pd5">苹果扫码下载</div>
      </div>
    </div>
<!--    <div class="contract-container flex flex-justify_between">-->
<!--      <div class="contract-wrap">-->
<!--        <div>-->
<!--          <div class="tag-group__title">申请额度(500)</div>-->
<!--          <el-tag-->
<!--              v-for="i in levers"-->
<!--              :key="i.id"-->
<!--              effect="dark" class="tag_div" :class="{'tab_active': leverId === i.id}">-->
<!--            {{ i.name }}-->
<!--          </el-tag>-->
<!--        </div>-->
<!--&lt;!&ndash;        <div class="pd5">确认信息</div>&ndash;&gt;-->
<!--&lt;!&ndash;        <div class="pd5">保证金</div>&ndash;&gt;-->
<!--&lt;!&ndash;        <div class="pd5">配资资金</div>&ndash;&gt;-->
<!--&lt;!&ndash;        <div class="pd5">总操盘资金</div>&ndash;&gt;-->
<!--&lt;!&ndash;        <div class="pd5">预警线</div>&ndash;&gt;-->
<!--&lt;!&ndash;        <div class="pd5">平仓线</div>&ndash;&gt;-->
<!--&lt;!&ndash;        <div class="pd5">利率</div>&ndash;&gt;-->
<!--&lt;!&ndash;        <div class="pd5">利息</div>&ndash;&gt;-->
<!--&lt;!&ndash;        <div class="pd5">合约期限</div>&ndash;&gt;-->
<!--&lt;!&ndash;        <div class="pd5">个股仓位限制</div>&ndash;&gt;-->
<!--        <div class="pd5">-->
<!--          <el-checkbox v-model="checked">我已阅读并同意</el-checkbox>-->
<!--          <div class="xy_div">《配置协议》</div>-->
<!--        </div>-->
<!--        <div class="pd5">-->
<!--          <div class="sub_btn">确认提交</div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="swiper-wrap" style="height: 550px">-->
<!--        <div class="title_div">-->
<!--          <div class="title_box" style="margin-left: 20px">进行中</div>-->
<!--          <div class="title_box">已结算</div>-->
<!--          <div class="title_box div_right">按天</div>-->
<!--          <div class="title_box div_right">按周</div>-->
<!--          <div class="title_box div_right">按月</div>-->
<!--          <div class="title_box div_right">免息</div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="tips-wrap">-->
<!--        <div>-->
<!--        </div>-->
<!--        <div class="pd5">安卓扫码下载</div>-->
<!--        <div style="margin-top: 20px">-->
<!--        </div>-->
<!--        <div class="pd5">苹果扫码下载</div>-->
<!--      </div>-->
<!--    </div>-->

  </div>

</template>

<script>
import { isContractPreview } from '@/utils/contractPreview'
import {apiAdded, apiAddedInfo, apiApplyInfo, apiBase, apiBaseData, apiStockCateList} from "@/utils/requestapis";
import {getCache} from "@/utils/cache";
import { resourceUrl } from '@/utils/realmName'

export default {
    data() {
      return {
        content: 0,
        checked: false,
        items: [
          {type: '', label: '标签一'},
          {type: 'success', label: '标签二'},
          {type: 'info', label: '标签三'},
          {type: 'danger', label: '标签四'},
          {type: 'warning', label: '标签五'}
        ],
        modes: [],
        levers: [],
        deposits: [],
        modeId: 1,
        depositId: 1,
        leverId: 1,
        depositIds: [],
        leverIds: [],
        bannerList: [],
        app: {
          android: '',//安卓下载页地址
          android_scan: '',//安卓下载页二维码
          iosApp: '',//苹果下载页地址
          iosApp_scan: '',//苹果下载页二维码
          iosH5_scan: ''//h5的页面
        },
        dialogVisible:false,
        submitting:false,
      };
    },
    mounted(){
      apiBase({}).then((res) => {
        let arr = res.ads_list
        for (let i=0;i<arr.length;i++){
          arr[i].img = resourceUrl(arr[i].img)
        }
        this.bannerList = arr
      })
      apiApplyInfo({}).then((res) => {
        this.modes = res.modes;
        this.levers = res.levers;
        this.deposits = res.deposits;
        if(this.modes.length > 0){
          let obj = this.modes[0]
          this.modeId = obj.id
          this.depositIds = obj.deposit.split(",")
          this.leverIds = obj.lever.split(",")
        }
      })
      let config_data = getCache('config_data');
      this.app = { ...config_data.app };
      this.app.android_scan = resourceUrl(this.app.android_scan)
      this.app.iosApp_scan = resourceUrl(this.app.iosApp_scan)
    },
    methods: {
      tagClick1(idx){
        let obj = this.modes[idx]
        this.modeId = obj.id
        this.depositIds = obj.deposit.split(",")
        this.leverIds = obj.lever.split(",")
      },
      checkLerver(id){
        if(this.leverIds.indexOf(id+'') >= 0){
          return true;
        }
        return false;
      },
      checkDeposits(id){
        if(this.depositIds.indexOf(id+'') >= 0){
          return true;
        }
        return false;
      },
      submitClick(){
        if (this.submitting) return
        if(this.checked) {
          this.submitting = true
          let obj ={
            modeId: this.modeId,
            depositId: this.depositId,
            leverId: this.leverId
          }
          return apiAddedInfo(obj).then((res) => {
            if(isContractPreview(res)){
              return this.$confirm('<div>\n' +
                  '      <div style="height: 36px">\n' +
                  '        <div style="float:left;">总操盘资金<i class="el-icon-question"></i></div>\n' +
                  '        <div style="float: right">'+res.money+'元</div>\n' +
                  '      </div>\n' +
                  '      <div style="height: 36px">\n' +
                  '        <div style="float:left;">保证金/本金</div>\n' +
                  '        <div style="float: right">'+res.deposit+'元</div>\n' +
                  '      </div>\n' +
                  '      <div style="height: 36px">\n' +
                  '        <div style="float:left;">配资金额</div>\n' +
                  '        <div style="float: right">'+res.funding+'元/'+res.multiple+'倍</div>\n' +
                  '      </div>\n' +
                  '      <div style="height: 36px">\n' +
                  '        <div style="float:left;">亏损预警线<i class="el-icon-question"></i></div>\n' +
                  '        <div style="float: right">'+res.loss_warn+'元</div>\n' +
                  '      </div>\n' +
                  '      <div style="height: 36px">\n' +
                  '        <div style="float:left;">亏损平仓线<i class="el-icon-question"></i></div>\n' +
                  '        <div style="float: right">'+res.loss_close+'元</div>\n' +
                  '      </div>\n' +
                  '      <div style="height: 36px">\n' +
                  '        <div style="float:left;">个股仓位限制</div>\n' +
                  '        <div style="float: right">'+res.position_limit+'%</div>\n' +
                  '      </div>\n' +
                  '      <div style="height: 36px">\n' +
                  '        <div style="float:left;">利率<i class="el-icon-question"></i></div>\n' +
                  '        <div style="float: right">'+res.ratio+'%</div>\n' +
                  '      </div>\n' +
                  '      <div style="height: 36px">\n' +
                  '        <div style="float:left;">产生利息</div>\n' +
                  '        <div style="float: right">'+res.interest+'元</div>\n' +
                  '      </div>\n' +
                  '      <div style="height: 36px">\n' +
                  '        <div style="float:left;">资金使用时间<i class="el-icon-question"></i></div>\n' +
                  '        <div style="float: right">'+res.days+'天</div>\n' +
                  '      </div>\n' +
                  '      <div style="height: 36px">\n' +
                  '        <div style="float:left;">可用利息券<i class="el-icon-question"></i></div>\n' +
                  '        <div style="float: right">'+res.coupon_money+'元</div>\n' +
                  '      </div>\n' +
                  '      <div style="height: 36px">\n' +
                  '        <div style="float:left;">返现冻结金额<i class="el-icon-question"></i></div>\n' +
                  '        <div style="float: right">'+res.blocked_money+'元</div>\n' +
                  '      </div>\n' +
                  '      <div style="height: 36px">\n' +
                  '        <div style="float:left;">准备资金<i class="el-icon-question"></i></div>\n' +
                  '        <div style="float: right">'+res.pre_money+'元</div>\n' +
                  '      </div>\n' +
                  '      <div style="height: 36px">\n' +
                  '        <div style="float:left;">利率分成<i class="el-icon-question"></i></div>\n' +
                  '        <div style="float: right">'+res.point+'%</div>\n' +
                  '      </div>\n' +
                  '    </div>', '确认申请', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                dangerouslyUseHTMLString: true,
                type: 'success',
                center: true
              }).then(() => {
                return apiAdded(obj).then((res) => {
                  if(res && res.code == 1){
                    this.$message({
                      type: 'info',
                      message: res.msg
                    });
                  }
                })
              }).catch(() => {
              });
            }
          }).catch(() => { /* Request failures are reported by the interceptor. */ }).finally(() => { this.submitting = false })
        }else{
          this.$message({
            message: '需要阅读协议并确认',
            type: 'error',
            duration: 5 * 1000
          })
        }

      }
    }
}
</script>

<style lang="scss" scoped>
    .contract-container {
        // width: 23.3224vw;
        border: 1px solid red;
        color: var(--theme-text);
        .contract-wrap {
            width: 23.3224vw;
            border: 1px solid blue;
        }
        .swiper-wrap {
            width: 47.6872vw;
            border: 1px solid green;
        }
        .tips-wrap {
            width: 23.648vw;
            border: 1px solid gray;
        }
        .title-wrap {
            height: 5.048vh;
            color: #e0b481;
            background-color: var(--theme-header);
        }

        // 轮播
        

        .ant-carousel .slick-slide h3 {
            color: #fff;
        }
    }

    ::v-deep .ant-carousel {
            text-align: center;
            height: 230px;
            line-height: 230px;
            background: #364d79;
            overflow: hidden;
        }
    .pd5{
      padding: 5px 10px;
    }
    .xy_div{
      color: #c1a34b;
      display: inline-block;
    }
    .sub_btn{
      background-color: #e0b481;
      padding: 10px;
      color: #000000;
      text-align: center;
      border-radius: 5px;
    }
    .title_box{
      float: left;
      height: 30px;
      line-height: 30px;
      background-color: var(--theme-bg);
      margin-right: 20px;
      cursor: pointer;
      color: #515a6e;
    }
    .div_right{
      float: right;
    }
    .title_div{
      width: 100%;
      background-color: var(--theme-bg);
      height: 30px;
      line-height: 30px;
    }
    .tips-wrap{
      color: var(--theme-label);
      text-align: center;
    }
    .tx-r{
      text-align: left !important;
    }
    .el-input__inner{
      background-color: var(--theme-panel);
      border: none;
    }

    .tag_div{
      cursor: pointer;
      background-color: #ffedeb;
      color: #000;
      margin: 10px;
      border: none;
      min-width: 70px;
      text-align: center;
    }
    .tag-group__title{
      padding: 10px;
    }
    .tab_active{
      background-color: #dd5054;
      color: #fff;
      border: none;
    }
    .hy_div{
      display: none;
    }
</style>
